export const formDataReducer = (state, action) => {
    switch (action.type) {
        case "SET_FORM_DATA":
            console.log({...state, ...action.payload})
            return {...state, ...action.payload}

        default:
            return state
    }
}